import type { OfferRewardDto, OfferRewardType } from "../api/dto/offers.dto.js";
import type { KeyHuntDto, KeyHuntRewardDto, KeyHuntRewardType, KeyHuntTaskDto } from "../api/dto/key_hunt.dto.js";
import type { LocalMetricEvent } from "../offline/local_metrics.js";

const OFFER_TYPE: Record<KeyHuntRewardType, OfferRewardType> = {
  coin: "coins",
  heart: "hearts",
  infinite_hearts: "infinite_hearts_minutes",
  no_ads: "no_ads_minutes",
  fireworks: "fireworks",
  multiballs: "multi_balls",
  big_balls: "big_balls",
  infinite_balls: "infinite_balls",
  mines: "mines",
};

const TITLE_KEYS: Record<string, string> = {
  complete_levels: "KEY_HUNT.TASK.COMPLETE_LEVELS",
  use_boosters: "KEY_HUNT.TASK.USE_BOOSTERS",
  watch_rewarded_ads: "KEY_HUNT.TASK.WATCH_ADS",
};

const MAX_METRICS = new Set( [ "level_streak" ] );

export function toOfferReward( reward: KeyHuntRewardDto ): OfferRewardDto
{
  return { type: OFFER_TYPE[reward.type] ?? ( reward.type as unknown as OfferRewardType ), amount: reward.amount };
}

export function keyHuntTitleKey( task: KeyHuntTaskDto ): string
{
  return task.title || TITLE_KEYS[task.metric] || `DAILY_TASKS.TASK.${task.metric.toUpperCase()}`;
}

export function refreshKeyHuntFlags( hunt: KeyHuntDto ): void
{
  hunt.keys = hunt.tasks.filter( task => task.claimed ).length;
  const full = hunt.keys >= hunt.keys_needed;
  for ( const task of hunt.tasks )
  {
    task.completed = task.claimed || task.progress >= task.target;
    task.claimable = task.completed && !task.claimed && !full;
    task.locked = !task.claimed && full;
  }
  hunt.safe_ready = full;
  hunt.prize_claimable = full && hunt.chosen_prize !== null && !hunt.prize_claimed;
}

export function applyKeyHuntMetrics( hunt: KeyHuntDto, events: LocalMetricEvent[] ): boolean
{
  let changed = false;
  for ( const event of events )
  {
    if ( !( event.amount > 0 ) ) continue;
    for ( const task of hunt.tasks )
    {
      if ( task.metric !== event.metric || task.claimed || task.progress >= task.target ) continue;
      if ( task.param !== null && task.param !== ( event.param ?? null ) ) continue;
      const amount = Math.floor( event.amount );
      const progress = MAX_METRICS.has( task.metric )
        ? Math.min( task.target, Math.max( task.progress, amount ) )
        : Math.min( task.target, task.progress + amount );
      if ( progress === task.progress ) continue;
      task.progress = progress;
      changed = true;
    }
  }
  if ( changed ) refreshKeyHuntFlags( hunt );
  return changed;
}
